// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, anyOf } from "@altostra/type-validations";
import { string, number, boolean, nullOrUndefined } from "@altostra/type-validations/lib/primitives";

export const isGenerativeAiAgentResult = objectOf({
  result: objectOf({
    id: string,
    name: string,
    description: string,
    marked_as_deleted: boolean,
    model: string,
    provider: number,
    prompt: string,
    braze_tool_ids: arrayOf(number),
    use_brand_guidelines: boolean,
    brand_guideline_id: anyOf(string, nullOrUndefined),
    created_at: number,
    updated_at: number,
    created_by: string,
    response_schema_json: anyOf(string, nullOrUndefined),
  }),
});
